import React from 'react'
import type { Document } from '@contentful/rich-text-types'
import type { ArticleBodyFragment } from '../../../.graphql/generated-types'
import type { Substitutions } from '../../components/ContentfulRichText'
import { ContentfulRichText } from '../../components/ContentfulRichText'

export interface ComposeComponentTextProps {
  data: ArticleBodyFragment
  substitutions: Substitutions
}
export function ArticleBody({
  data,
  substitutions,
}: ComposeComponentTextProps) {
  if (data.richTextBody?.json) {
    return (
      <ContentfulRichText
        document={data.richTextBody.json as Document}
        entries={data.richTextBody.links.entries}
        substitutions={substitutions}
        className="my-6 space-y-6 text-lg"
      />
    )
  }
  return null
}
